import React from "react";

export default function Yeh() {
  return (
    <div className="yeh">
      <div className="container">
        <div className="row">
          <div className="col-12">
            <h1>
              <img
                src="./Asserts/quote-left.svg"
                className="img-fluid quote-left"
                alt=""
              />
              &nbsp; Yhea , lot of Murukami in the
              <br /> hallway – drake &nbsp;{" "}
              <img
                src="./Asserts/quote-right.svg"
                className="img-fluid quote-right"
                alt=""
              />
            </h1>
          </div>
        </div>
      </div>
    </div>
  );
}
